import { Reducer } from 'redux'

import {
  FETCH_BREAD_CRUMBS_PROFILE,
  FetchBreadCrumbsProfileAction,
} from 'actions/seo/breadCrumbsAction'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'

export interface SeoLink {
  text: string
  url: string
}

export interface BreadCrumbsState {
  profileLinks: SeoLink[]
}

const initialState: BreadCrumbsState = {
  profileLinks: [],
}

export const breadCrumbsReducer: Reducer<
  BreadCrumbsState,
  FetchBreadCrumbsProfileAction
> = (state = initialState, action): BreadCrumbsState => {
  switch (action.type) {
    case FETCH_BREAD_CRUMBS_PROFILE:
      return defaultPromiseReducer(state, action, undefined, (result) => {
        if (result) {
          return {
            profileLinks: result,
          }
        }

        return state
      })

    default:
      return state
  }
}
